import { useTheme } from "styled-components"

const ToggleIcon = ({ fill }) => {
  const {
    palette: {
      turquoise: { mid }
    }
  } = useTheme()

  return (
    <svg viewBox="-50 0 300 29" style={{ width: "20vw", height: "5vw" }}>
      <polygon
        points="5,70 100,0 195,70"
        stroke="#607c93"
        strokeWidth={36}
        strokeDasharray="1 1"
        fill={fill ?? mid}
      />
    </svg>
  )
}

export default ToggleIcon
